// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
// 对齐 EB view/admin/src/components/base/index.js：自动注册 base 目录下公共组件
import type { App, Component } from 'vue';

type NamedComponent = Component & { name?: string };

const files = import.meta.glob<NamedComponent>('./*.vue', { eager: true, import: 'default' });

export default {
  install(app: App) {
    Object.values(files).forEach((component) => {
      if (component?.name) {
        app.component(component.name, component);
      }
    });
  },
};
